import {Component, OnDestroy} from '@angular/core';
import {TabItemModel} from '../../../../models/tab-item-model';
import {ShareService} from "../../../../services/share.service";
import {Subscription} from "rxjs";
import {ValidationService} from "../../../../services/validation.service";

@Component({
  selector: 'app-install-general',
  templateUrl: './install-general.component.html',
  styleUrls: ['./install-general.component.scss'],

})
export class InstallGeneralComponent implements OnDestroy {
  public tabs: TabItemModel[] = [
    {id: 0, label: 'Gateway', route: 'gateway', isDisabled: false, isVisible: true, isInvalid: false},
    {id: 1, label: 'Vorher-Fotos', route: 'pre-photos', isDisabled: false, isVisible: true, isInvalid: false},
    {id: 2, label: 'Aufmaß', route: 'measurement', isDisabled: false, isVisible: true, isInvalid: false},
    {id: 3, label: 'Absenden', route: 'sending', isDisabled: false, isVisible: true, isInvalid: false},
  ];

  private subscriptions: Subscription[] = [];

  constructor(
    private shareService: ShareService,
    private validationService: ValidationService,
  ) {
    this.subscriptions.push(this.shareService.generalGateway$.subscribe(gateway => this.tabs[0].isInvalid = !this.validationService.isGeneralGatewayValid(gateway)));
    this.subscriptions.push(this.shareService.generalPrePhotos$.subscribe(prePhotos => this.tabs[1].isInvalid = !this.validationService.isGeneralPrePhotosValid(prePhotos)));
    this.subscriptions.push(this.shareService.generalMeasurement$.subscribe(measurement => this.tabs[2].isInvalid = !this.validationService.isGeneralMeasurementValid(measurement)));
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
